import React, { Component } from 'react';
import PropTypes from 'prop-types';

/**
 * Component that alerts if you click outside of it
 */
export default class ServiceOutsideAlerter extends Component {

  constructor(props) {
    super(props);
    this.setServiceRef = this.setServiceRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  /**
   * Set the wrapper ref
   */
  setServiceRef(node) {
    this.serviceWrapperRef = node;
  }

  /**
   * Alert if clicked on outside of element
   */
  handleClickOutside(event) {
    if (this.serviceWrapperRef && !this.serviceWrapperRef.contains(event.target)) {
      this.props.closeServiceOrderFilter();
    }
  }

  render() {
    return <div ref={this.setServiceRef}>{this.props.children}</div>;
  }
}

ServiceOutsideAlerter.propTypes = {
  children: PropTypes.element.isRequired,
};
